<template>
  <custom-dialog title="优惠券核销" :showClose="true" width="403px" v-if="visibleShow" :visible="visibleShow" @close="close"
    :saveBtnTitle="!dialogObj.cantUseReason ? '确定' : '扫描其他优惠券'" @save="save" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="content" slot="content">
      <div class="content_tips"> {{ dialogObj.cantUseReason ? '该优惠券不可用！' : '确定使用以下优惠券？'  }} </div>
       <div class="content_coupon" :class="{ 'disabled': dialogObj.cantUseReason }" >
        <div class="coupon_type">{{  computedDictText(dialogObj.newType, couTypeList)}}</div>
        <div class="coupon_price">
          <span>￥</span>
          <span class="size28">{{ dialogObj.couMoney }}</span>
        </div>
        <div class="coupon_tips" v-if="dialogObj.couFloorMoney > 0">满{{ dialogObj.couFloorMoney }}可用</div>
        <div class="coupon_tips" v-else>无门槛</div>
        <div class="coupon_date">{{ computedDate(dialogObj.couEndTime)}} 到期</div>
        <div class="coupon_reason" v-if="dialogObj.cantUseReason">{{ dialogObj.cantUseReason }}</div>
        <!-- <div class="coupon_main" :class="{ 'disabled': dialogObj.cantUseReason }">
          <div class="coupon_left">
            <div class="coupon_left_price">
              <span>￥</span>
              <span class="size28">{{ dialogObj.couMoney }}</span>
            </div>
            <div class="coupon_left_condition" v-if="dialogObj.couFloorMoney > 0">满{{ dialogObj.couFloorMoney }}可用</div>
            <div class="coupon_left_condition" v-else>无门槛</div>
          </div>
          <div class="coupon_right">
            <div class="coupon_right_title">
              <div class="coupon_type">{{ computedDictText(dialogObj.newType, couTypeList) }}</div>
              <div class="coupon_name">{{ dialogObj.couName || '' }}</div>
            </div>
            <div class="coupon_right_date">{{ dialogObj.couEndTime }} 到期</div>
          </div>
        </div> -->
        <!-- <div class="coupon_bottom">
          <div>
            <div :class="showMore ? '' : 'lineOne'" v-if="!dialogObj.cantUseReason">
              <div v-if="dialogObj.newType == '2'">适用医生：{{ dialogObj.doctorNamesStr }}</div>
              <div v-if="dialogObj.newType == '2'">适用门店：{{ dialogObj.deptNamesStr }}</div>
              <div v-if="dialogObj.newType == '1' && dialogObj.isBlack == '1'">适用商品：除{{ dialogObj.medicineNamesStr }}之外的商品
              </div>
              <div v-if="dialogObj.newType == '1' && dialogObj.isBlack == '2'">适用商品：{{ dialogObj.medicineNamesStr }}</div>
            </div>
            <div :class="showMore ? '' : 'lineOne'" v-else>
              <span class="colorF54A">不可用原因：</span>
              <span class="color0000">{{ dialogObj.cantUseReason }}</span>
            </div>
            <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="coupon_bottom_icon"
              @click="showMore = !showMore"></i>
          </div>
        </div> -->
      </div>
      <div class="mt24">
        <el-button type="primary" @click="save">{{ dialogObj.cantUseReason ? '扫码其他优惠券' : '去使用' }} </el-button>
      </div>
    </div>
    <div slot="footer"></div>
  </custom-dialog>
</template>

<script>
import customDialog from '@/components/customDialog/CustomDialog'
import { couTypeList } from '@/utils/const'
import { dictText } from '@/utils/validateBase'
export default {
  components: { customDialog },
  props: {
    visibleShow: {
      type: Boolean,
      default: false
    },
    dialogObj: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      showMore: false,
      couTypeList: couTypeList
    }
  },
  computed: {
    computedDictText() {
      return function (value, list) {
        return dictText(value, list)
      }
    },
    computedDate() {
      return function (value) {
        return this.$moment(value).format('YYYY-MM-DD')
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save', this.dialogObj)
    }
  }
}
</script>

<style lang="less" scoped>
.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed !important;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.content_tips {
  color: #000;
  font-size: 14px;
  font-weight: 400;
}

.content_coupon {
  width: 180px;
  padding: 0 12px 16px;
  background: hsl(42, 100%, 95%);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #FFDB8A;
  margin-top: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.coupon_type{
  color: #68481D;
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  height: 24px;
  line-height: 24px;
  background: #FFE6AC;
  border-radius: 0px 0px 8px 8px;
}
.coupon_price{
  color: #68481D;
  font-weight: bold;
  font-size: 18px;
  margin-top: 26px;
}
.coupon_tips{
  color: #68481D;
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
}
.coupon_date{
  color: #989085;
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;
}
.coupon_reason{
  padding-top: 8px;
  color: #F54A45;
  font-size: 13px;
  line-height: 16px;
  border-top: 1px dashed #E0E0E0;
  margin-top: 8px ;
}
</style>